import { lazy } from 'react';

import { AuthRoute } from 'modules/auth/routes/auth-route';

const Dashboard = lazy(() => import('./dashboard'));

export default {
  routes: [<AuthRoute exact key="/dashboard" path="/dashboard" render={() => <Dashboard />} />],
};
